<!--<button mat-raised-button (click)="restore()" color="primary">Restore</button>-->
<button (click)="restore()" class="cell-history-action-btn" mat-icon-button color="primary">
  <mat-icon>settings_backup_restore</mat-icon>
</button>
